import { FC, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import DropDown from "../../components/DropDown";
import { GetSummaryList } from "../../redux/actions/summaryAction";
import { fetchStateData } from "../../redux/actions/dataActions";
import Pagination from "../../components/pagination";
import { hasPermission } from "../../config/permissionUtils";
import { GetCommunityList } from "../../redux/actions/communityAction";
import { GetAccessibilityList } from "../../redux/actions/accessibilityAction";

interface SoilListType {
  data: any[];
  pageIndex: number;
  pageSize: number;
  totalrecords: number;
  totalPage: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

const Accessibility: FC = () => {
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions } = usePermissions();
  const dispatch = useDispatch<AppDispatch>();

  const [CurrentPage, SetCurrentPage] = useState(1);
  const [pgsize] = useState(10);
  const [market_name, set_market_name] = useState("");
  const [profile_id, set_profile_id] = useState<number | "">("");
  const [profile_name, set_profile_name] = useState("");
  const [stateOptions, setStateOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedState, setSelectedState] = useState("");
  const [city, set_city] = useState("");

  const [TotalRecords, setTotalRecords] = useState(0);

  const [soilList, setSoilList] = useState<SoilListType>({
    data: [],
    pageIndex: 1,
    pageSize: 10,
    totalrecords: 0,
    totalPage: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  useEffect(() => {
    fetchStateOptions();
  }, []);

  useEffect(() => {
    searchCommunity();
  }, [CurrentPage]);

  const fetchStateOptions = async () => {
    const payload = { stateid: null, statename: null };
    dispatch(
      fetchStateData(payload, (response: any) => {
        if (Array.isArray(response?.data)) {
          const formattedOptions = response.data.map((item: any) => ({
            label: item.statename,
            value: item.statename,
          }));
          setStateOptions(formattedOptions);
        }
      })
    );
  };

  const searchCommunity = () => {
    const payload = {
      PageIndex: CurrentPage,
      PageSize: pgsize,
      SkipRow: pgsize * (CurrentPage - 1),
      SortBy: null,
      SortOrder: "desc",
      accessibilityid: null,
      market_name: market_name,
      profile_name: profile_name,
      profile_id: profile_id || null,
      city: city,
      state: selectedState,
    };

    dispatch(
      GetAccessibilityList(payload, (response: any) => {
        if (response?.status !== 500) {
          setSoilList(response);
          setTotalRecords(response.totalrecords || 0);
        }
      })
    );
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4">
          <div className="container">
            <div className="d-flex justify-content-between align-items-end">
              <div>
                <div className="loginHd mb-1">
                  <span className="d-block">F2F Accessiblity</span>
                </div>
                <div className="bradcrumb">
                  <NavLink to="/dashboard">Dashboard</NavLink> &gt; F2F Accessiblity
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Filters */}
        <section className="filterCon">
          <div className="container">
            <div className="d-flex flex-wrap align-items-center pt-3 pb-3">
              <div className="searchBy">Search By</div>
              <ul className="d-flex flex-wrap filterBox">
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Market Name</span>
                    <input
                      type="text"
                      className="filterInput"
                      value={market_name}
                      onChange={(e) => set_market_name(e.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-2">
                  <div className="position-relative">
                    <span className="field">Profile ID</span>
                    <input
                      type="number"
                      className="filterInput"
                      value={profile_id}
                      onChange={(e) =>
                        set_profile_id(
                          e.target.value ? parseInt(e.target.value) : ""
                        )
                      }
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Profile Name</span>
                    <input
                      type="text"
                      className="filterInput"
                      value={profile_name}
                      onChange={(e) => set_profile_name(e.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-2">
                  <div className="position-relative">
                    <span className="field">City</span>
                    <input
                      type="text"
                      className="filterInput"
                      value={city}
                      onChange={(e) => set_city(e.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-2">
                  <div className="position-relative">
                    <span className="field">State</span>
                    <DropDown
                      options={stateOptions}
                      onChange={(e) => setSelectedState(e.target.value)}
                      className="filterInput"
                      Title="Select State"
                    />
                  </div>
                </li>
                <li className="btn">
                  <button
                    type="button"
                    onClick={() => {
                      SetCurrentPage(1);
                      searchCommunity();
                    }}
                  >
                    <span className="material-icons">search</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Table */}
        <section className="pt-4 pb-4 mt-2 whtBg">
          <div className="container">
            <div className="tableBox">
              <table>
                <thead>
                  <tr>
                    <th>Market Name</th>
                    <th>Profile Id</th>
                    <th>Profile Name</th>
                    <th>City</th>
                    <th>State</th>
                    {hasPermission(permissions, roleid, "Soil", "view") && (
                      <th>Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {soilList.data?.length ? (
                    soilList.data.map((item: any) => (
                      <tr key={`summary-${item.summaryid}`}>
                        <td>{item.market_name}</td>
                        <td>{item.profile_id}</td>
                        <td>{item.profile_name}</td>
                        <td>{item.city}</td>
                        <td>{item.state}</td>
                        {hasPermission(permissions, roleid, "Soil", "view") && (
                          <td>
                            <div className="actionbtn d-flex">
                              <NavLink
                                to={`/Accessibility/view/${item.accessibilityid}`}
                                title="View"
                              >
                                <span className="material-icons-outlined">
                                  visibility
                                </span>
                              </NavLink>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>No records found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center pt-3 pb-3">
              <div className="totalResul">{TotalRecords} Results</div>
              <Pagination
                GoToPage={(value: number) => SetCurrentPage(value)}
                PageIndex={soilList.pageIndex}
                TotalPages={soilList.totalPage}
                hasNextPage={soilList.hasNextPage}
                hasPreviousPage={soilList.hasPreviousPage}
              />
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Accessibility;
